import moment from 'moment';
import 'moment/locale/id';
// import axios from "@/axios/index.js"

const state = {
    sso_access_token: null,
    sso_refresh_token: null,
    expired: null,
    refresh_expired: null,
    sso_user_id: null,
    sso_client_id: null,
    sso_user_status: null,
    sso_user_role: null,
    simadu_role: null,
    simadu_registrasi: null,
    loading: false,
    alert: '',
    show: false,
    backColor: '',
    data_edit: null,
    bsi_client_id: '2576',
    bni_client_id: '29873',
    bni_prefix: '988',
    btn_prefix: '95673000000',
    mandiri_client_id: '88976',
    payment: null,
    biodata: null,
    tahun_aktif: null,
    tahun_ajaran: null,
    semester: null,
    semester_aktif: null,
    fakultas: null,
    fakultas_aktif: null,
    prodi: null,
    prodi_aktif: null,
    cuti: null,
    herreg: null,
    aktif: false,
    ikut_paket: false,
    list_role: [],
    role_aktif: null,
    kalender_aktif: null,
    kalender: null,
    menuMode: 'sidebar',
    scheme: 'light',
    theme: null,
    force: false,
    kalender_bayar_aktif: null,
};

const mutations = {
    set_login_token(state, tokens) {
        // console.log(tokens, "set store login");
        state.sso_access_token = tokens.accessToken;
        state.sso_refresh_token = tokens.refreshToken;
        state.sso_client_id = tokens.client.id;
        state.sso_user_id = tokens.user.id;
        state.expired = tokens.accessTokenExpiresAt;
        state.refresh_expired = tokens.refreshTokenExpiresAt;
        state.sso_username = tokens.user.username;
        state.sso_user_status = tokens.user.user_status;
        state.sso_user_role = tokens.user.role;
    },
    set_intercept_token(state, tokens) {
        // console.log(tokens)
        state.sso_access_token = tokens.accessToken;
        state.sso_refresh_token = tokens.refreshToken;
        state.sso_client_id = tokens.client.id;
        state.sso_user_id = tokens.user.id;
        state.expired = tokens.accessTokenExpiresAt;
        state.sso_username = tokens.user.username;
    },
    set_clear_token(state) {
        // console.log("set_clear");
        state.sso_access_token = null;
        state.sso_refresh_token = null;
        state.sso_client_id = null;
        state.sso_user_id = null;
        state.expired = null;
        state.sso_username = null;
        state.sso_user_status = null;
        state.sso_user_role = null;
        state.simadu_role = null;
        state.role_aktif = null;
        state.semester_aktif = null;
        state.tahun_aktif = null;
        state.list_role = [];
        state.prodi_aktif = null;
        state.fakultas_aktif = null;
    },
    force_logout(state, status) {
        state.force = status;
    },
    set_loading_state(state, value) {
        state.loading = value;
    },
    changeMenuMode(state, menu) {
        state.menuMode = menu;
    },
    change_color_scheme(state, scheme) {
        state.scheme = scheme;
    },
    show_alert_success(state, value) {
        state.alert = value.toUpperCase();
        state.backColor = 'background-color: #91f086';
        state.show = true;
    },
    show_alert_fail(state, value) {
        state.alert = value.toUpperCase();
        state.backColor = 'background-color: #FF6962';
        state.show = true;
    },
    set_kalender_aktif(state, value) {
        // console.log(value,'kalender aktif');
        state.kalender_aktif = value;
    },
    set_kalendar_bayar_aktif(state, value) {
        // console.log(value,'kalender aktif');
        state.kalender_bayar_aktif = value;
    },
    set_kalender(state, value) {
        // console.log(value,'kalender');
        state.kalender = value;
    },
    hide_alert(state) {
        state.alert = '';
        state.show = false;
    },
    set_data_edit(state, value) {
        state.data_edit = value;
    },
    set_payment(state, value) {
        state.payment = null;
        state.payment = value;
    },
    simadu_registrasi(state, value) {
        state.simadu_registrasi = value;
    },
    simadu_role(state, value) {
        if (value.role == 'Mahasiswa') {
            state.simadu_role = null;
            value.nama_role = value.role;
            state.simadu_role = value;
            state.list_role = null;
        } else {
            state.simadu_role = null;
            value.nama_role = value.role;
            state.simadu_role = value;
        }
    },
    set_data_biodata(state, value) {
        (value.nama_tanggal_lahir = moment(value.tanggal_lahir).format('LL')),
            (value.nama_tanggal_lahir_ayah = moment(value.tanggal_lahir_ayah).format('LL')),
            (value.nama_tanggal_lahir_ibu_kandung = moment(value.tanggal_lahir_ibu_kandung).format('LL')),
            (value.nama_tanggal_lahir_wali = moment(value.tanggal_lahir_wali).format('LL')),
            (value.tanggal_lahir = moment(value.tanggal_lahir).format('YYYY-MM-DD')),
            (value.tanggal_lahir_ayah = moment(value.tanggal_lahir_ayah).format('YYYY-MM-DD')),
            (value.tanggal_lahir_ibu_kandung = moment(value.tanggal_lahir_ibu_kandung).format('YYYY-MM-DD')),
            (value.tanggal_lahir_wali = moment(value.tanggal_lahir_wali).format('YYYY-MM-DD')),
            (state.biodata = value);
    },
    set_tahun_aktif(state, value) {
        // console.log(value,' store tahun aktif');
        state.tahun_aktif = value;
    },
    set_semester_aktif(state, value) {
        // console.log(value,' store tahun aktif');
        state.semester_aktif = value;
    },
    set_fakultas_aktif(state, value) {
        // console.log(value,' store fakultas aktif');
        state.fakultas_aktif = value;
    },
    set_prodi_aktif(state, value) {
        // console.log(value,' store prodi aktif');
        state.prodi_aktif = value;
    },
    set_tahun_ajaran(state, value) {
        state.tahun_ajaran = value;
    },
    set_fakultas(state, value) {
        value.unshift({ value: null, text: 'Pilih Semua' });
        state.fakultas = value;
    },
    set_prodi(state, value) {
        value.unshift({ value: null, text: 'Pilih Semua' });
        state.prodi = value;
    },
    set_cuti(state, value) {
        if (value) {
            state.cuti = value;
        } else {
            state.cuti = null;
        }
    },
    set_semester(state, value) {
        state.semester = value;
    },
    set_herreg(state, value) {
        state.herreg = null;
        if (value) {
            state.herreg = value;
        } else {
            state.herreg = null;
        }
    },
    set_aktif(state, value) {
        state.aktif = value;
    },
    set_ikut_paket(state, value) {
        state.ikut_paket = value;
    },
    set_list_role(state, value) {
        state.list_role = value;
    },
    set_role_aktif(state, value) {
        state.role_aktif = value;
    },
    change_role_aktif(state, value) {
        console.log(value)
        state.role_aktif = value;
        let x = state.prodi;
        let k = state.fakultas;
        if (value.prodi_id) {
            for (let i = 0; i < x.length; i++) {
                if (value.prodi_id == x[i].prodi_id) {
                    // console.log(x[i].text);
                    state.prodi_aktif = x[i].value;
                }
            }
        }
        if (value.fakultas_id) {
            for (let l = 0; l < k.length; l++) {
                if (value.fakultas_id == k[l].id) {
                    // console.log(k[l].text);
                    state.fakultas_aktif = k[l].value;
                }
            }
        }
    },
};
const actions = {
    save_token_login({ commit }, log_respon) {
        // console.log(log_respon,'store login')
        commit('set_login_token', log_respon);
    },
    save_token_intercept({ commit }, int_respon) {
        commit('set_intercept_token', int_respon);
    },
    clear_token({ commit }) {
        commit('set_clear_token');
    },
    set_loading({ commit }, value) {
        commit('set_loading_state', value);
    },
    set_alert_show_success({ commit }, value) {
        commit('show_alert_success', value);
    },
    set_alert_show_fail({ commit }, value) {
        commit('show_alert_fail', value);
    },
    set_alert_hide({ commit }) {
        commit('hide_alert');
    },
    set_data_edit({ commit }, value) {
        commit('set_edit_data', value);
    },
    set_biodata({ commit }, value) {
        commit('set_data_biodata', value);
    },
    set_profil({ commit }, value) {
        commit('set_data_profil', value);
    },
    payment({ commit }, value) {
        // console.log(value, 'tagihan');
        if (value) {
            let x = value.tahun_kb.includes('-1');
            let v = value.tahun_kb.substring(0, 4);
            if (x) {
                value.semester = v + ' Ganjil';
            } else {
                value.semester = v + ' Genap';
            }
            commit('set_payment', value);
        } else {
            commit('set_payment', null);
        }
    },
    set_simadu_role({ commit }, value) {
        // console.log(value,'store role simadu');
        commit('simadu_role', value);
    },
    save_ikut_paket({ commit }, value) {
        // console.log(value,' store tahun aktif');
        commit('set_ikut_paket', value);
    },
    save_tahun_aktif({ commit }, value) {
        // console.log(value,' store tahun aktif');
        commit('set_tahun_aktif', value);
    },
    save_tahun_ajaran({ commit }, value) {
        // console.log(value,'tahun_ajaran');
        commit('set_tahun_ajaran', value);
    },
    save_fakultas({ commit }, value) {
        // console.log(value,'fakultas');
        commit('set_fakultas', value);
    },
    save_prodi({ commit }, value) {
        // console.log(value,'prodi');
        commit('set_prodi', value);
    },
    save_semester_aktif({ commit }, value) {
        // console.log(value,'store semester_aktif');
        commit('set_semester_aktif', value);
    },
    save_prodi_aktif({ commit }, value) {
        // console.log(value,'prodi_aktif');
        commit('set_prodi_aktif', value);
    },
    save_cuti({ commit }, value) {
        // console.log(value,'prodi_aktif');
        commit('set_cuti', value);
    },
    save_semester({ commit }, value) {
        // console.log(value,'store semester');
        commit('set_semester', value);
    },
    save_herreg({ commit }, value) {
        if (value) {
            commit('set_herreg', value);
        } else {
            commit('set_herreg', null);
        }
    },
    save_list_role({ commit, state }, value) {
        // console.log(value, state.simadu_role);
        if (state.simadu_role.role != 'Mahasiswa') {
            if (state.simadu_role.role != 'Super Admin') {
                // console.log('okeh');
                value.unshift(state.simadu_role);
            }
            if (state.role_aktif == null) {
                commit('change_role_aktif', value[0]);
            } else {
                let x = value.filter((r) => {
                    return r.kode_role == state.role_aktif.kode_role;
                });
                if (x.length != 0) {
                    commit('change_role_aktif', state.role_aktif);
                } else {
                    commit('change_role_aktif', value[0]);
                }
            }
        }
        commit('set_list_role', value);
    },
};
// const modules = {};
// const plugins = [createPersistedState({
//   storage: {
//     getItem: key => Cookies.get(key),
//     setItem: (key, value) => Cookies.set(key, value, { expires: 3, secure: true }),
//     removeItem: key => Cookies.remove(key)
//   }
// })];
// const plugins = [createPersistedState()];
export const simadu = {
    state,
    mutations,
    actions,
    // modules,
    // plugins,
};
